var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyebrows4E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new_eyes__x2F__eyebrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyebrows_x5F_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400.7,226c-9.3,0.3-22.6,3.1-28.2,11.9c-0.8,1.3-2.9,5.5-1.2,6.9c1.8,1.4,4.7-2,5.8-3.2c3.5-3.9,6.5-6.5,11.4-8.5 c10.1-4.1,20.6-5.3,31.2-2c2.1,0.6,4.4,1.7,6.6,2.3c0.9,0.3,3.7,1.2,4.6,1.5c-3.9-2.2-9.1-5.3-13.5-6.6 C412.1,226.8,406.2,225.8,400.7,226z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M388.3,233.1c-4.9,2-7.9,4.6-11.4,8.5 c-1,1.2-3.8,4.3-5.6,3.3c5.5,6.3,13.9-4.4,18.8-7.4c7.2-4.5,15.6-6.4,24.1-5.9c2.4,0.1,5.5,0.1,8.4,0.6c-1-0.4-2-0.8-3-1.1 C408.9,227.8,398.4,228.9,388.3,233.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M427,233.6c0.1,0,0.1,0.1,0.2,0.1C427.2,233.7,427.1,233.7,427,233.6C427.1,233.6,427,233.6,427,233.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M313.3,226c9.3,0.3,22.6,3.1,28.2,11.9c0.8,1.3,2.9,5.5,1.2,6.9c-1.8,1.4-4.7-2-5.8-3.2c-3.5-3.9-6.5-6.5-11.4-8.5 c-10.1-4.1-20.6-5.3-31.2-2c-2.1,0.6-4.4,1.7-6.6,2.3c-0.9,0.3-3.7,1.2-4.6,1.5c3.9-2.2,9.1-5.3,13.5-6.6 C301.9,226.8,307.7,225.8,313.3,226z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M325.6,233.1c4.9,2,7.9,4.6,11.4,8.5c1,1.2,3.8,4.3,5.6,3.3 c-5.5,6.3-13.9-4.4-18.8-7.4c-7.2-4.5-15.6-6.4-24.1-5.9c-2.4,0.1-5.5,0.1-8.4,0.6c1-0.4,2-0.8,3-1.1 C305,227.8,315.5,228.9,325.6,233.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M286.9,233.6c-0.1,0-0.1,0.1-0.2,0.1C286.8,233.7,286.8,233.7,286.9,233.6L286.9,233.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyebrows4E);
export default __webpack_public_path__ + "static/media/eyebrows_4e.483d53763ea88a3e84dd3d6f3f1bfb12.svg";
export { ForwardRef as ReactComponent };